module.exports = __webpack_public_path__ + "static/media/chat-user.096d91ce.svg";